/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CustomPresetDto } from '../../models/custom-preset-dto';

export interface GetCustomLayers$Params {}

export function getCustomLayers(
  http: HttpClient,
  rootUrl: string,
  params?: GetCustomLayers$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CustomPresetDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomLayers.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomPresetDto>;
      }),
    );
}

getCustomLayers.PATH = '/me/layers';
